/* eslint-disable indent */
import styled from 'styled-components';

import { Item as DataItem } from './CardData.styles';
import PinLocationIcon from '../../../assets/v2/PinLocationIcon';
import PinLocationOutlineIcon from '../../../assets/v2/PinLocationOutlineIcon';
import { COLORS } from '../../../theme';

export const Item = styled(DataItem)`
  position: relative;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.s4};
  }

  &::before {
    position: absolute;
    left: 10px;
    width: 1px;
    background-color: ${COLORS.black10};
    content: '';
  }

  ${({ $alignTop, $variant }) =>
    $variant === 'start' &&
    `
      &::before {
        top: ${$alignTop ? '15px' : '50%'};
        bottom: 0;
        transform: translateY(14px);
      }
  `}
  ${({ $alignTop, $variant }) =>
    $variant === 'end' &&
    `
      &::before {
        top: ${$alignTop ? '-14px' : 0};
        bottom: ${$alignTop ? '100%' : '50%'};
        transform: translateY(${$alignTop ? 0 : '-14px'});
      }
  `}
`;

export const StyledPinLocationIcon = styled(PinLocationIcon)`
  && {
    path {
      fill: ${COLORS.kinetikBlue};
    }
  }
`;

export const StyledPinLocationOutlineIcon = styled(PinLocationOutlineIcon)`
  path:first-child {
    fill: transparent;
    stroke: ${COLORS.black40};
  }

  path:last-child {
    fill: ${COLORS.black40};
    stroke: ${COLORS.black40};
  }
`;
